import { render } from "./imagesView.vue?vue&type=template&id=515b61ed"
import script from "./imagesView.vue?vue&type=script&lang=js"
export * from "./imagesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__